import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/TabbedPage.css';
//import FX from './functions/functions';



class TabbedPage extends Component {
  constructor(props) {
    super(props);
    this.state = { pageNumber: 0 };
  }
  search = () => {
    var search_str;
    if(document.getElementById("search_text")){
      search_str = document.getElementById("search_text").value;
    }
    console.log(search_str);
  }
  showPage = (i) => {
    this.setState({pageNumber: i});
  }
  render() {
    var className = 'TabbedPage';
    
    var pageNumber = 0;
    if(this.state.pageNumber){
      pageNumber = this.state.pageNumber;
    }
    
    var page;
    if(Array.isArray(this.props.children)){
      page = this.props.children[pageNumber];
    }
    else {
      page = this.props.children;
    }
    var buttons;
    if(this.props.buttons){
      buttons = this.props.buttons.map((btn, i) => {
        if(btn.show === undefined || btn.show){
            var className = '';
            if(i == pageNumber){
              className += ' active';
              return '';
            }
            return <button className={className} onClick={this.showPage.bind(this,i)}>{btn.text}</button>;
        }
      })
    }
    return (
      <div className={this.props.className + ' ' + className}>
        <div>
            {page}
        </div>
        <div className="pageButtons">
            {buttons}
        </div>
      </div>
    );
  }
}

export default TabbedPage;



// WEBPACK FOOTER //
// ./src/TabbedPage.js